import moment from 'moment'

import { n, y } from './constant'
import { notEmpty } from './regex'

export const ternary = (bool, truthy, falsy) => (bool ? truthy : falsy)

export const equal = (obj1, obj2 = 0) => obj1 === obj2

export const head = (obj) => obj[0]

export const last = (obj) => obj[length(obj) - 1]

export const length = (obj) => obj?.length

export const entries = (obj) => Object.entries(obj)

export const values = (object) => (object ? Object.values(object) : [])

export const keys = (object) => (object ? Object.keys(object) : [])

export const isEmpty = (value) => {
  if (typeof value === 'string' && isEmptyString(value)) return true
  if (typeof value === 'object' && equal(length(keys(value)))) return true
  return false
}

export const isEmptyString = (value) =>
  value === '' || value === undefined || value === null

export const lowerCase = (value) => value.toLowerCase()

export const spaceBetween = (value) =>
  value?.replace(/([A-Z|0-9|_])/g, ' $1').trim()

export const getDate = (value, format = 'YYYY-MM-DD HH:mm a') =>
  moment(value).locale('de_DE').format(format)

export const isArray = (obj) => Array.isArray(obj)

export const checkVal = (val) => val ?? ''

export const getName = (firstName, lastName) => {
  const name = `${checkVal(firstName)} ${checkVal(lastName)}`
  if (notEmpty(name)) return spaceBetween(name)
  return '-'
}

export const checkUndefined = (obj) => obj === undefined

export const isNaN = (val) => Number.isNaN(val)

export const isBool = (value) => typeof value === 'boolean'

export const notNull = (value) => value !== null

export const checkIncludes = (value, array) => array.includes(value)

export const modifyNumber = (value) => {
  const number = value?.toString().split('.')
  if (number) {
    if (number[0].length >= 5) {
      number[0] = number[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    }
    if (number[1] && number[1].length >= 5) {
      number[1] = number[1].replace(/(\d{3})/g, '$1,')
    }
  }
  return number?.join('.')
}

export const capitalizeString = (val) =>
  val.replace(/\b\w/g, (c) => c.toUpperCase())

export const replaceChar = (val) => val.replace(/_/g, ' ')

// export const getBoolean = (val) => (val ? y : n)
export const getBoolean = (val) => ternary(val, y, n)
